import { parseFilename } from './files';
import axios from 'axios';
import { PAYROLL_JOURNAL_BASE_URL } from '../constants';

export { downloadBlob } from './files';

export interface PayrollEmployeeFigures {
  gross: number;
  ee_pension?: number;
  ee_nic: number;
  tax: number;
  net_pay: number;
  er_nic: number;
  er_pension?: number;
}

export interface PayrollJournalSummary {
  period_str: string;
  date_display: string;
  balanced: boolean;
  total_dr: number;
  total_cr: number;
  total_tax: number;
  total_ee_nic: number;
  total_er_nic: number;
  total_net_pay: number;
  employees: Record<string, PayrollEmployeeFigures>;
}

export interface PayrollJournalResult {
  blob: Blob;
  filename: string;
  summary: PayrollJournalSummary | null;
}

export async function calculatePayrollJournal(
  payrollFile: File,
  outputFilename?: string
): Promise<PayrollJournalResult> {
  const formData = new FormData();
  formData.append('payroll_file', payrollFile);
  if (outputFilename && outputFilename.trim()) {
    formData.append('output_filename', outputFilename.trim());
  }

  try {
    const response = await axios.post(
      `${PAYROLL_JOURNAL_BASE_URL}/payroll-journal/calculate`,
      formData,
      { responseType: 'blob' }
    );

    const blob = response.data as Blob;
    const filename = parseFilename(
      response.headers['content-disposition'] || null,
      outputFilename || 'Payroll_Journal.xlsx'
    );

    let summary: PayrollJournalSummary | null = null;
    const rawSummary = response.headers['x-summary'];
    if (rawSummary) {
      try {
        summary = JSON.parse(rawSummary) as PayrollJournalSummary;
      } catch {
        summary = null;
      }
    }

    return { blob, filename, summary };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const errorBlob = error.response?.data as Blob | undefined;
      const contentType = String(error.response?.headers?.['content-type'] || '');
      const data =
        errorBlob && contentType.includes('application/json')
          ? JSON.parse(await errorBlob.text())
          : null;
      const message = (data && data.detail) || `Calculation failed with status ${error.response?.status}`;
      throw new Error(message);
    }
    throw error;
  }
}
